<template>
    <div class="content-i">
    <div class="content-box">
        <div class="full-chat-w">
                <div class="full-chat-i">
                    <div class="full-chat-left scrollable">
            <StatementRail :statements="statements"/>
                    </div>
                    </div>
        </div>

    </div>
</div>
</template>

<script>
import StatementRail from '@/components/billing/StatementRail'

export default {
  components: {
    StatementRail
  },
  data () {
    return {
      client: '',
      statements: ''
    }
  },
  mounted () {
    this.getStatements()
  },
  methods: {
    getStatements: function () {
      var self = this
      const url = '/billing/statements'
      self.$store.dispatch('updateLoading', 'true')
      this.$http
        .post(url, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          console.log(response)
          self.client = response.data.client
          self.statements = response.data.statements
          self.$store.dispatch('updateLoading', 'false')
        })
        .catch(function (error) {
          console.log(error)
          self.$store.dispatch('showToastAPIError')
        })
    }
  }
}
</script>
